<template>
  <div class="vue-upload-multiple-image">
    <div class="image-list">
      <div v-for="(img, idx) in localImages" :key="idx" class="image-item">
        <img :src="img.path" class="preview-img" />
        <button type="button" class="btn-remove" @click="removeImage(idx)">&times;</button>
      </div>
      <label class="add-btn">
        <input type="file" multiple accept="image/*" @change="onFilesChange" />
        <span>+ Add Images</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VueUploadMultipleImage',
  props: {
    dataImages: { type: Array, default: () => [] },
    idUpload: { type: String, default: 'upload' },
    editUpload: { type: String, default: 'edit' },
  },
  emits: ['upload-success', 'before-remove', 'edit-image'],
  data() {
    return {
      localImages: [],
    };
  },
  watch: {
    dataImages: {
      immediate: true,
      handler(val) {
        this.localImages = Array.isArray(val) ? [...val] : [];
      },
    },
  },
  methods: {
    onFilesChange(e) {
      const files = Array.from(e.target.files);
      files.forEach((file, i) => {
        const reader = new FileReader();
        reader.onload = (ev) => {
          const imgObj = { path: ev.target.result, highlight: 0, default: 0 };
          this.localImages.push(imgObj);
          const fd = new FormData();
          fd.append('file', file);
          this.$emit('upload-success', fd, this.localImages.length - 1, [...this.localImages]);
        };
        reader.readAsDataURL(file);
      });
      e.target.value = '';
    },
    removeImage(index) {
      const done = () => {
        this.localImages.splice(index, 1);
      };
      this.$emit('before-remove', index, done, [...this.localImages]);
    },
  },
};
</script>

<style scoped>
.vue-upload-multiple-image { display: flex; flex-wrap: wrap; gap: 8px; }
.image-list { display: flex; flex-wrap: wrap; gap: 8px; align-items: flex-start; }
.image-item { position: relative; width: 80px; height: 80px; }
.image-item .preview-img { width: 100%; height: 100%; object-fit: cover; border-radius: 4px; }
.btn-remove {
  position: absolute; top: 2px; right: 2px;
  background: rgba(0,0,0,.55); color: #fff; border: none;
  border-radius: 50%; width: 18px; height: 18px;
  line-height: 1; cursor: pointer; font-size: 12px; padding: 0;
}
.add-btn {
  display: flex; align-items: center; justify-content: center;
  width: 80px; height: 80px; border: 2px dashed #ccc;
  border-radius: 4px; cursor: pointer; font-size: 12px;
  color: #666; flex-direction: column; text-align: center;
}
.add-btn input[type="file"] { display: none; }
</style>
